import createIcon from '../../createIcon';

/**
 * @component @name Thirtyfps
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA1VjhIOFYxMC41SDNWMTMuNUg4VjE2SDJWMTlIOEM5LjY2IDE5IDExIDE3LjY2IDExIDE2VjE0LjFDMTEgMTIuOTQgMTAuMDYgMTIgOC45IDEyQzEwLjA2IDEyIDExIDExLjA2IDExIDkuOVY4QzExIDYuMzQgOS42NiA1IDggNUgyWk0xOSA4VjE2SDE1VjhIMTlaTTE5IDVIMTVDMTMuMzQgNSAxMiA2LjM0IDEyIDhWMTZDMTIgMTcuNjYgMTMuMzQgMTkgMTUgMTlIMTlDMjAuNjYgMTkgMjIgMTcuNjYgMjIgMTZWOEMyMiA2LjM0IDIwLjY2IDUgMTkgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Thirtyfps = createIcon('Thirtyfps', [
  [
    'path',
    {
      d: 'M2 5V8H8V10.5H3V13.5H8V16H2V19H8C9.66 19 11 17.66 11 16V14.1C11 12.94 10.06 12 8.9 12C10.06 12 11 11.06 11 9.9V8C11 6.34 9.66 5 8 5H2ZM19 8V16H15V8H19ZM19 5H15C13.34 5 12 6.34 12 8V16C12 17.66 13.34 19 15 19H19C20.66 19 22 17.66 22 16V8C22 6.34 20.66 5 19 5Z',
      key: '1kg3kt',
    },
  ],
]);

export default Thirtyfps;
